import HeaderRowPanel from './HeaderRowPanel';
import Standard from './Standard';

const EXPORT = {
  HeaderRowPanel,
  Standard,
};

export default EXPORT;
